import React from 'react';
import './types/window';
window.__MAKER_NAV_REACT__ = window.__MAKER_NAV_REACT__ || React;
export default window.__MAKER_NAV_REACT__;
